import { PLAYER_ANALYTICS_DEV, PLAYER_ANALYTICS_PROD, PLAYER_ANALYTICS_TEST } from '@anm/constants/domains';
var supportedExtensions = ['mp4', 'webm', 'ogg', 'mov', 'm3u8'];
var configs = {
  dev: {
    cdnUrl: 'https://embed.wave-test.video',
    apiUrl: 'https://api.wave-test.video/v2',
    analyticsUrl: PLAYER_ANALYTICS_DEV,
    supportedExtensions: supportedExtensions
  },
  test: {
    cdnUrl: 'https://embed.wave-test.video',
    apiUrl: 'https://api.wave-test.video/v2',
    analyticsUrl: PLAYER_ANALYTICS_TEST,
    supportedExtensions: supportedExtensions
  },
  prod: {
    cdnUrl: 'https://embed.wave.video',
    apiUrl: 'https://api.wave.video/v2',
    analyticsUrl: PLAYER_ANALYTICS_PROD,
    supportedExtensions: supportedExtensions
  }
};
var currentEnv = process.env['TS_ENV'];
if (!currentEnv) throw new Error('Missed env: TS_ENV');

var playerConfig = function playerConfig(env) {
  return configs[env || currentEnv];
};

export default playerConfig;